import { salesHttp } from "@salesdi";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
var cRepositories = repositories(salesHttp);
var cUseCases = useCases(cRepositories);
var cActions = actions();
var cPresenters = presenters(cActions, cUseCases);
export default cPresenters;
